const MapStyle = {
  DEFAULT:
    process.env.REACT_APP_GEOLLECT_BASEMAP ??
    'mapbox://styles/geollectryan/cm0cfrvr500s801ph2rte0yoz', // default to prod
  RISK_INTELLIGENCE: 'mapbox://styles/geollectryan/cliso5mvc009t01p7daaqcxpq',
  SATELLITE_IMAGERY: 'mapbox://styles/geollectryan/clgkv2v6l008p01pc8efqbz34',
};

export default MapStyle;
